<template>
    <div :class="$style['input']">
        <MaskedInput v-if="type === 'tel'"
                     mask="\+ 7 (111) 111-11-11"
                     pattern="^[0-9-()+\s]+$"
                     placeholder="+ 7 (ХХХ) ХХХ-ХХ-ХХ"
                     :class="$style['input__input']"
                     :name="name"
                     :id="name"
                     :required="required"
                     @input="change"
                     ref="input"/>

        <input v-else
               ref="input"
               :type="type || 'text'"
               :name="name"
               :id="name"
               :required="required"
               :class="$style['input__input']"
               :placeholder="placeholder"
               data-validate-required="true"
               @input="change($event.target.value)">

        <div :class="$style['input__line']"></div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input';

    export default {
        props: ['value', 'name', 'type', 'placeholder', 'required'],

        model: {
            prop: 'value',
            event: 'change'
        },

        components: {
            MaskedInput
        },

        methods: {
            change(val) {
                this.$emit('change', val);
            }
        }
    }
</script>

<style lang="scss" module>
    // SETTINGS
    $color-placeholder: rgba($brand-dark-brown, 0.6);
    $color-placeholder-hover: rgba($brand-dark-brown, 0.8);
    $input-color: $brand-dark-brown;
    $input-brd: rgba($brand-dark-brown, 0.3);
    $input-line: $brand-dark-brown;
    $input-bg-disabled: rgba($brand-dark-brown, 0.15);

    .input {
        position: relative;
        width: 100%;
        color: $input-color;
    }

    .input__input {
        @include font-size(p2);
        @include scale(padding-bottom, 13, 13, 13);
        display: block;
        width: 100%;
        border: none;
        border-bottom: 1px solid rgba($brand-dark-brown, 0.3);
        background-color: transparent;
        color: $input-color;

        &::placeholder {
            @include transition(color);
            @include font-size(p2);
            color: $color-placeholder;
        }

        &:hover {
            &::placeholder {
                color: $color-placeholder-hover;
            }
        }

        &:focus {
            & + .input__line {
                &:after {
                    width: 100%;
                }
            }
        }

        &[disabled="disabled"] {
            background-color: $input-bg-disabled;

            &:hover {
                &::placeholder {
                    color: $color-placeholder;
                }
            }
        }
    }

    .input__line {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 1px;

        &:after {
            @include transition(width);
            @include pseudo();
            bottom: 0;
            left: 0;
            width: 0;
            height: 1px;
            background-color: $input-line;
            transition-duration: 0.15s;
            transition-timing-function: ease-in;
        }
    }
</style>
